import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { PopoverCard } from '@99designs/react-components/components/PopoverCard';

export default class Annotation extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = e => {
            e.stopPropagation();
            this.props.onClick();
        };

        this.onMouseDown = e => {
            e.stopPropagation();
        };
    }

    card() {
        return <div className="annotation__content">{this.props.children}</div>;
    }

    button() {
        return (
            <button
                className={classNames({
                    annotation__marker: true,
                    'annotation__marker--deleting': this.props.isDeleting && this.props.isSelected,
                })}
                style={{
                    left: this.props.position.x,
                    top: this.props.position.y,
                }}
            />
        );
    }

    render() {
        return (
            <div
                className="annotation"
                onClick={this.onClick}
                onMouseDown={this.onMouseDown}
                data-focus={this.props.isSelected || undefined}
            >
                <PopoverCard
                    variations={[this.props.isSelected ? '' : 'hidden']}
                    layerSelector="#design-details-annotations-anchor"
                    card={this.card()}
                >
                    {this.button()}
                </PopoverCard>
            </div>
        );
    }
}

Annotation.propTypes = {
    children: PropTypes.node,
    isDeleting: PropTypes.bool,
    isSaving: PropTypes.bool,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    position: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/Annotation.jsx